import { memo, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import newImg from '../../../assets/images/color_plus_icon.png';
import LoadingSaveBtn from '../../forms/LoadingSaveBtn';
import PopupModal from '../modals/PopupModal';
import HidePrescriptionItemModal from '../modals/hidePrescriptionItem';

const PrescriptionSaveBtns = ({
  templateId,
  loadingStatus,
  handleSubmit,
  prescriptionId,
  resetPrescription,
  setIsTemplateModal,
  patientInfo,
  selectedChiefComplains,
  selectedDiagnosis,
  selectedInvestigations,
  selectedHistories,
  selectedOnExamination,
  selectedMedicines,
  selectedAdvices,
  selectedFollowUps,
  hideItems,
  setHideItems,
  leftOrRightItems,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [disableButtons, setDisableButtons] = useState(true);
  const [disableTemplateCreateButton, setDisableTemplateCreateButton] =
    useState(true);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    console.log('nam and dob: ', patientInfo?.name, patientInfo?.dob);
    if (
      patientInfo?.name &&
      (patientInfo?.dob?.years ||
        patientInfo?.dob?.months ||
        patientInfo?.dob?.days ||
        patientInfo?.dob?.hours)
    ) {
      setDisableButtons(false);
    } else {
      setDisableButtons(true);
    }

    if (
      selectedChiefComplains?.length > 0 ||
      selectedDiagnosis?.length > 0 ||
      selectedInvestigations?.length > 0 ||
      selectedMedicines?.length > 0 ||
      selectedAdvices?.length > 0 ||
      selectedFollowUps?.length > 0 ||
      Object.keys(selectedHistories).length > 0 ||
      Object.keys(selectedOnExamination).length > 0
    ) {
      setDisableTemplateCreateButton(false);
    } else {
      setDisableTemplateCreateButton(true);
    }
  }, [
    patientInfo,
    selectedChiefComplains,
    selectedDiagnosis,
    selectedInvestigations,
    selectedHistories,
    selectedOnExamination,
    selectedMedicines,
    selectedAdvices,
    selectedFollowUps,
  ]);

  return (
    <Row className="prescription-save-btn mb-2 mt-5 footer-area">
      <div
        className="d-flex justify-content-start button-area text-center"
        style={{ width: '100%' }}
      >
        {loadingStatus ? (
          <LoadingSaveBtn />
        ) : (
          <Button
            variant="primary"
            className="mr-1 save-button button-left-round"
            size="md"
            onClick={() => handleSubmit('save')}
            // disabled={disableButtons}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-save"
              viewBox="0 0 16 16"
            >
              <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1z" />
            </svg>
            <span className="pl-2">Save</span>
          </Button>
        )}
        {loadingStatus ? (
          <LoadingSaveBtn />
        ) : (
          <Button
            variant="primary"
            className="mr-1 save-button"
            size="md"
            onClick={() => handleSubmit('saveAndPrint')}
            // disabled={disableButtons}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-printer"
              viewBox="0 0 16 16"
            >
              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
            </svg>
            <span className="pl-2">Save & Print</span>
          </Button>
        )}
        <Button
          variant="primary"
          className="mr-1 save-button"
          size="md"
          onClick={() => setIsShow(true)}
          // disabled={disableButtons}
        >
          <i className="fa fa-tasks" />
          <span className="pl-2">Custom Print</span>
        </Button>
        <PopupModal
          resetPrescription={resetPrescription}
          showConfirmModal={showConfirmModal}
          setShowConfirmModal={setShowConfirmModal}
        />
        <HidePrescriptionItemModal
          isShow={isShow}
          setIsShow={setIsShow}
          hideItems={hideItems}
          setHideItems={setHideItems}
          leftOrRightItems={leftOrRightItems}
          handleSubmit={handleSubmit}
        />
        <div className="new-pres-btn">
          <img
            src={newImg}
            title="Create New Prescription"
            height={55}
            width={55}
            style={{ backgroundColor: 'white' }}
            alt=""
            onClick={() =>
              prescriptionId ? resetPrescription() : setShowConfirmModal(true)
            }
          />
        </div>
        <Button
          variant="primary"
          className="mr-1 save-button button-right-round"
          size="md"
          onClick={() => setIsTemplateModal(true)}
          // disabled={disableTemplateCreateButton}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-file-earmark-ruled"
            viewBox="0 0 16 16"
          >
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5zM3 12v-2h2v2zm0 1h2v2H4a1 1 0 0 1-1-1zm3 2v-2h7v1a1 1 0 0 1-1 1zm7-3H6v-2h7z" />
          </svg>
          <span className="pl-2">
            {templateId ? 'Update' : 'Save'} Template
          </span>
        </Button>
      </div>
      {/* <Col className="button-area text-center">
        {loadingStatus ? (
          <LoadingSaveBtn />
        ) : (
          <Button
            variant="primary"
            className="mr-3 save-button"
            size="md"
            onClick={() => handleSubmit('saveAndPrint')}
            // disabled={disableButtons}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-printer"
              viewBox="0 0 16 16"
            >
              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
            </svg>
            <span className="pl-2">Save & Print</span>
          </Button>
        )}
      </Col> */}
      {/* <Col className="button-area text-right">
        <PopupModal
          resetPrescription={resetPrescription}
          showConfirmModal={showConfirmModal}
          setShowConfirmModal={setShowConfirmModal}
        />
        <div className="new-pres-btn">
          <img
            src={newImg}
            title="Create New Prescription"
            height={55}
            width={55}
            style={{ backgroundColor: 'white' }}
            alt=""
            onClick={() =>
              prescriptionId ? resetPrescription() : setShowConfirmModal(true)
            }
          />
        </div>
        <Button
          variant="primary"
          className="mr-3 save-button button-right-round"
          size="md"
          onClick={() => setIsTemplateModal(true)}
          // disabled={disableTemplateCreateButton}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-file-earmark-ruled"
            viewBox="0 0 16 16"
          >
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5zM3 12v-2h2v2zm0 1h2v2H4a1 1 0 0 1-1-1zm3 2v-2h7v1a1 1 0 0 1-1 1zm7-3H6v-2h7z" />
          </svg>
          <span className="pl-2">
            {templateId ? 'Update' : 'Save'} Template
          </span>
        </Button>
      </Col> */}
    </Row>
  );
};

export default memo(PrescriptionSaveBtns);
